import { render, staticRenderFns } from "./dialog-base.vue?vue&type=template&id=7ef96585"
import script from "./dialog-base.vue?vue&type=script&lang=js"
export * from "./dialog-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports